import type { IPortalAccountEmailAddress, IPortalAccountPhoneNumber } from '../../api/domain';
import type { IRootState } from '../root-reducer';

export const getUserPortalAccount = (state: IRootState) => state.portalAccountApi.portalAccount;
export const getPortalAccounts = (state: IRootState) => state.portalAccountApi.portalAccounts;
export const getUserId = (state: IRootState) => state.portalAccountApi.portalAccount && state.portalAccountApi.portalAccount.ownerUserExternalId;

export const getUserPortalAccountMailAddresses = (state: IRootState): IPortalAccountEmailAddress[] => {
    const portalAccount = getUserPortalAccount(state);

    return (portalAccount && portalAccount.emailAddresses) || [];
};
export const getUserPortalAccountPhoneNumbers = (state: IRootState): IPortalAccountPhoneNumber[] => {
    const portalAccount = getUserPortalAccount(state);

    return (portalAccount && portalAccount.phoneNumbers) || [];
};

export const getMailNotificationsEnabled = (state: IRootState) => {
    const mailAddresses = getUserPortalAccountMailAddresses(state);

    return (mailAddresses.length && mailAddresses[0].forNotification) || false;
};
export const getPhoneNotificationsEnabled = (state: IRootState) => {
    const phoneNumbers = getUserPortalAccountPhoneNumbers(state);

    return (phoneNumbers.length && phoneNumbers[0].forNotification) || false;
};

export const getMetadata = (state: IRootState) => state.portalAccountApi.portalAccount && state.portalAccountApi.portalAccount.metadata;

export const getMetadataByKey = (state: IRootState, key: string) => state.portalAccountApi.portalAccount?.metadata?.find((metadata) => metadata.key === key);
